import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { useCrud } from '@/hooks/useCrud'
import { createQueryKey } from '@/lib/react-query'
import service from './file.service'
import { API_RESOURCE } from '@/constants/api.constant'

const useFile = () => {
  const baseCrud = useCrud(API_RESOURCE.FILE)

  const queryClient = useQueryClient()

  const useUploadFile = () => {
    return useMutation({
      mutationFn: (data) => service.uploadFile(data),
      onSuccess: (res) => {},
      onError: (error) => {
        if (error.response?.status === 413) {
          toast.error('File is too large')
        } else if (error.response?.data?.message) {
          toast.error('Upload file failed')
        }
      },
    })
  }
  const useDownloadFile = () => {
    return useMutation({
      mutationFn: (id) => service.downloadFile(id),
    })
  }

  const useViewFileOnSharepoint = (id) =>
    useQuery({
      queryKey: baseCrud.queryKey.detail(id),
      queryFn: () => () => service.getFileDetailOnSharepoint(id),
      enabled: id !== '',
      placeholderData: keepPreviousData,
    })

  return {
    useFetchFile: baseCrud.useFetchOne,
    useRemoveFile: baseCrud.useRemove,
    useUploadFile,
    useDownloadFile: useDownloadFile,
    useViewFileOnSharepoint: useViewFileOnSharepoint,
  }
}

export default useFile
